// extracted by mini-css-extract-plugin
module.exports = {"root":"clients-module--root--28P3Z","wrapper":"clients-module--wrapper--dlvdY","clientIcons":"clients-module--clientIcons--3QMk2"};